"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Element = require("../../atoms/Element");

var _VideoController = require("./controllers/VideoController");

var _Spotlight = _interopRequireDefault(require("./plugins/Spotlight"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./VideoPlayer.css");

var _useVideoInfo2 = require("./useVideoInfo");

var _useVideoControls2 = require("./useVideoControls");

var _ = require("../..");

var _Watermark = _interopRequireDefault(require("./plugins/Watermark"));

var _excluded = ["containerRef", "moment", "zoomed", "muted", "playbackRate", "startAt", "startAtOnce", "stopAt", "freeze", "loop", "children", "spotlight", "trackingPlaylistId", "trackingPlaylistType", "trackingUserId", "trackingPlayerType", "trackingCategory", "trackingAction", "watermark", "plugins", "coachAudio", "cameras", "defaultCamera", "noMulticam", "mainVideoCallbackRef", "forceActive"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Video Player
var VideoPlayer = function VideoPlayer(_ref) {
  var containerRef = _ref.containerRef,
      moment = _ref.moment,
      zoomed = _ref.zoomed,
      muted = _ref.muted,
      playbackRate = _ref.playbackRate,
      startAt = _ref.startAt,
      startAtOnce = _ref.startAtOnce,
      stopAt = _ref.stopAt,
      freeze = _ref.freeze,
      loop = _ref.loop,
      children = _ref.children,
      spotlight = _ref.spotlight,
      trackingPlaylistId = _ref.trackingPlaylistId,
      trackingPlaylistType = _ref.trackingPlaylistType,
      trackingUserId = _ref.trackingUserId,
      trackingPlayerType = _ref.trackingPlayerType,
      trackingCategory = _ref.trackingCategory,
      trackingAction = _ref.trackingAction,
      watermark = _ref.watermark,
      plugins = _ref.plugins,
      coachAudio = _ref.coachAudio,
      cameras = _ref.cameras,
      defaultCamera = _ref.defaultCamera,
      noMulticam = _ref.noMulticam,
      mainVideoCallbackRef = _ref.mainVideoCallbackRef,
      forceActive = _ref.forceActive,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)("video-player-".concat(containerRef.current)),
      _useState2 = _slicedToArray(_useState, 1),
      videoId = _useState2[0];

  var _useVideoInfo = (0, _useVideoInfo2.useVideoInfo)(containerRef),
      active = _useVideoInfo.active,
      readyState = _useVideoInfo.readyState,
      multicamOpen = _useVideoInfo.multicamOpen;

  var _useVideoControls = (0, _useVideoControls2.useVideoControls)(containerRef),
      toggleMulticam = _useVideoControls.toggleMulticam;

  var controller = _VideoController.VideoController.getInstance(containerRef.current); // effect to control plugin setup and video controller destruction


  (0, _react.useEffect)(function () {
    // Add spotlight
    if (spotlight && !controller.hasPlugin("Spotlight")) {
      controller.addPlugin(new _Spotlight.default());
    } // Add watermark


    if (watermark && !controller.hasPlugin("Watermark")) {
      controller.addPlugin(new _Watermark.default());
    } // add plugins


    if (plugins && Array.isArray(plugins)) {
      var _iterator = _createForOfIteratorHelper(plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;
          controller.addPlugin(plugin);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } // need ejection handler


    return function () {
      console.log("VideoPlayer controller.destroy", containerRef === null || containerRef === void 0 ? void 0 : containerRef.current);
      controller.destroy();
    };
  }, []); // effect to update video controller

  (0, _react.useEffect)(function () {
    var sources = buildSources(noMulticam, moment);
    var camerasWithId = buildCamerasWithIds(noMulticam, cameras, sources, moment); // update controller with latest tracking stuff

    var cameraIds = camerasWithId.map(function (c) {
      return c.game_clip_id;
    }).sort(); // filter out 0 camera ids to match source ids

    cameraIds = cameraIds.filter(function (id) {
      return id !== 0;
    });
    var sourceIds = sources.map(function (s) {
      return s.game_clip_id;
    }).sort();

    if (JSON.stringify(cameraIds) === JSON.stringify(sourceIds)) {
      controller.update(moment, videoId, camerasWithId, defaultCamera);
    }
  }, [videoId, moment, defaultCamera]); // update the video controllers dumb properties
  // that do not need additional logic or checks

  controller.playlistId = trackingPlaylistId;
  controller.playlistType = trackingPlaylistType;
  controller.userId = trackingUserId;
  controller.category = trackingCategory;
  controller.action = trackingAction;
  controller.playerType = trackingPlayerType;
  controller.startAtOnce = startAtOnce;

  if (playbackRate) {
    controller.playbackRate = playbackRate;
  }

  if (loop !== null && loop !== undefined) {
    controller.loop = loop;
  }

  controller.startAt = startAt;
  controller.stopAt = stopAt;
  controller.freeze = freeze;
  controller.muted = muted; // end of dumb video settings updates
  // get the class names for the video player

  var classNames = ["VideoPlayer"];

  if (active || forceActive) {
    classNames.push("active");
  }

  if (zoomed && !multicamOpen && !(0, _.isSmallMobileScreen)()) {
    classNames.push("zoomed");
  }

  var sources = buildSources(noMulticam, moment);
  var camerasWithId = buildCamerasWithIds(noMulticam, cameras, sources, moment);
  return /*#__PURE__*/_react.default.createElement(_Element.Element, {
    id: videoId,
    className: classNames.join(" ")
  }, !noMulticam && /*#__PURE__*/_react.default.createElement(_Element.Element, {
    className: "sub-videos"
  }, /*#__PURE__*/_react.default.createElement(_Element.Element, {
    className: "sub-videos-content"
  }, camerasWithId.map(function (camera) {
    var cameraTitle = camera.title;
    var sourceExists = sources.some(function (source) {
      return source.meta.camera.name === camera.name;
    });
    var streamOverlayColor = sourceExists ? _.Color.White2 : _.Color.Grey3;
    var streamOverlayClass = sourceExists ? "" : "no-stream";
    return /*#__PURE__*/_react.default.createElement(_Element.Element, {
      trkAction: "".concat(camera.type, " Pressed"),
      key: "".concat(videoId, "-sub-container-").concat(camera.name, "-").concat(camera.game_clip_id),
      id: "".concat(videoId, "-sub-container-").concat(camera.name, "-").concat(camera.game_clip_id),
      className: "sub-video-container",
      onClick: function onClick(e) {
        return controller.onChangeSource(e.target.id.replace("container", ""));
      }
    }, /*#__PURE__*/_react.default.createElement("video", {
      id: "".concat(videoId, "-sub-").concat(camera.name, "-").concat(camera.game_clip_id),
      className: "sub-video",
      playsInline: true,
      muted: true,
      autoPlay: true
    }), /*#__PURE__*/_react.default.createElement(_.Column, {
      className: "video-info-overlay ".concat(streamOverlayClass),
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_.Label, {
      center: true,
      type: _.Label.Type.SmallBody,
      bold: true,
      color: streamOverlayColor,
      content: cameraTitle,
      className: "camera-title",
      marginTop: "1"
    })));
  }), /*#__PURE__*/_react.default.createElement(_.RoundButton, {
    trkAction: "Close Pressed",
    icon: _.Icon.Type.Close,
    backgroundColor: _.Color.Transparent,
    iconColor: _.Color.White2,
    iconSize: 24,
    onClick: function onClick(e) {
      return toggleMulticam(e);
    },
    marginLeft: "4",
    width: 40,
    height: 40
  }))), /*#__PURE__*/_react.default.createElement(_Element.Element, {
    className: "video-player-container"
  }, /*#__PURE__*/_react.default.createElement(_Element.Element, {
    className: "video-container"
  }, readyState <= 2 && /*#__PURE__*/_react.default.createElement(_Element.Element, {
    className: "large-loading"
  }), camerasWithId.map(function (camera) {
    return /*#__PURE__*/_react.default.createElement("video", {
      ref: function ref(node) {
        if (typeof mainVideoCallbackRef === "function") {
          mainVideoCallbackRef(node);
        }
      },
      key: "".concat(videoId, "-main-").concat(camera.name, "-").concat(camera.game_clip_id),
      id: "".concat(videoId, "-main-").concat(camera.name, "-").concat(camera.game_clip_id),
      "data-trk-ctx": "Video",
      className: "main-video",
      playsInline: true,
      muted: true,
      autoPlay: true
    });
  }), moment && moment.meta && moment.meta.type === "CoachAudio" && /*#__PURE__*/_react.default.createElement("audio", {
    key: "".concat(videoId, "-main-audio"),
    id: "".concat(videoId, "-main-audio"),
    className: "coach-audio"
  }), /*#__PURE__*/_react.default.createElement("canvas", null))), children);
}; // Helper


exports.VideoPlayer = VideoPlayer;

var cameraSortIndex = function cameraSortIndex(camera) {
  if (camera.name === "tracecam") return 5;
  if (camera.name === "multi-cam") return 15;
  return 10;
};

var buildSources = function buildSources(noMulticam, moment) {
  var tmpSources = [];

  if (moment) {
    if (noMulticam) {
      var momentWithSinglecam = _objectSpread({}, moment);

      momentWithSinglecam.meta = {
        camera: {
          name: "singlecam",
          title: "singlecam"
        }
      };
      tmpSources.push(momentWithSinglecam);
    } else {
      tmpSources.push(moment);

      if (Array.isArray(moment.sources)) {
        tmpSources = tmpSources.concat(moment.sources);
      }
    }
  }

  return tmpSources;
};

var buildCamerasWithIds = function buildCamerasWithIds(noMulticam, cameras, sources, moment) {
  var cids = [];

  if (noMulticam) {
    cids.push({
      title: "singlecam",
      name: "singlecam",
      game_clip_id: (0, _.getProperty)("game_clip_id", moment, 0)
    });
  } else if (cameras && sources) {
    var _iterator2 = _createForOfIteratorHelper(cameras),
        _step2;

    try {
      var _loop = function _loop() {
        var camera = _step2.value;
        var src = sources.find(function (src) {
          var cn = (0, _.getProperty)("meta.camera.name", src, null);
          return cn === camera.name;
        });
        cids.push(_objectSpread(_objectSpread({}, camera), {}, {
          game_clip_id: (0, _.getProperty)("game_clip_id", src, 0)
        }));
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  } // Order the cameras


  cids.sort(function (a, b) {
    var aIdx = cameraSortIndex(a);
    var bIdx = cameraSortIndex(b);
    var delta = aIdx - bIdx;

    if (delta === 0 && a && a.name && b && b.name) {
      delta = a.name.localeCompare(b.name);
    }

    return delta;
  });
  return cids;
};

VideoPlayer.propTypes = {
  moment: _propTypes.default.object,
  controller: _propTypes.default.object,
  zoomed: _propTypes.default.bool,
  muted: _propTypes.default.bool,
  forceActive: _propTypes.default.bool
};